module.exports = __webpack_public_path__ + "img/BuzzMusic-AllAlong.63109124.jpg";